export default __webpack_public_path__ + "static/media/IMG_4988-min.0c6c7d63.JPG";